import cn from 'classnames'
import { observer } from 'mobx-react'
import React from 'react'

import { Button, Hierarchy, SubVariant } from '@flowwai-frontend/design-system'
import { useCustomT } from '@flowwai-frontend/shared/common-components'

import { IMAGE_URLS } from '../../constants'
import * as Styles from './styles'

interface Props {
   onSetPIN: () => void
}

const PINNotConfigured = (props: Props): React.ReactElement => {
   const t = useCustomT('iam:userPIN')

   const renderSetPINButton = () => (
      <Button
         hierarchy={Hierarchy.Primary}
         size={'Small'}
         subVariant={SubVariant.Primary}
         onClick={props.onSetPIN}
      >
         {t('setPIN')}
      </Button>
   )

   return (
      <div
         className={cn(
            Styles.notConfiguredContainerStyles,
            'bg-white',
            'border-gray-300'
         )}
      >
         <div className={Styles.notConfiguredInnerStyles}>
            <img
               className='w-[130px]'
               src={IMAGE_URLS.PIN_NOT_CREATED_ICON}
               alt={t('notConfiguredTitle')}
            />
            <div className={Styles.notConfiguredTextContainerStyles}>
               <p
                  className={cn(
                     Styles.notConfiguredTitleStyles,
                     'text-gray-900'
                  )}
               >
                  {t('notConfiguredTitle')}
               </p>
               {renderSetPINButton()}
            </div>
         </div>
      </div>
   )
}

export default observer(PINNotConfigured)
